import { type KeyboardEvent, useEffect } from 'react'

import { AGENT_FRAME_SELECTOR } from '../components/widget/agentFrameMarker'
import { isHoverEscape, isWidgetEscape, POPUP_SELECTOR } from '../domain/widgetEscape'

/**
 * ウィジェットの枠の onKeyDown に渡す Esc の処理を返す。Esc で onEscape を呼ぶ。
 * フォーカスがウィジェットの中にあるときは枠の onKeyDown で受け、フォーカスがなくポインターが枠の上にあるときは document で受ける
 */
export const useAgentEscapeKey = (onEscape: () => void): ((event: KeyboardEvent<HTMLElement>) => void) => {
  // 入口を押して開くと、押した入口のボタンが消えてフォーカスが外れ（body に戻り）、Esc が枠に届かないので、document で受ける
  useEffect(() => {
    const handleDocumentKeyDown = (event: globalThis.KeyboardEvent): void => {
      const { activeElement } = document
      const handled =
        isHoverEscape({
          key: event.key,
          isComposing: event.isComposing,
          // eslint-disable-next-line sonarjs/deprecation,@typescript-eslint/no-deprecated -- isComposing だけでは Safari で漏れるため
          keyCode: event.keyCode,
          nothingFocused: activeElement === null || activeElement === document.body,
        }) && document.querySelector(`${AGENT_FRAME_SELECTOR}:hover`) !== null
      if (handled) {
        onEscape()
      }
    }
    document.addEventListener('keydown', handleDocumentKeyDown)
    return (): void => {
      document.removeEventListener('keydown', handleDocumentKeyDown)
    }
  }, [onEscape])

  return (event) => {
    const { target } = event
    const handled = isWidgetEscape({
      key: event.key,
      isComposing: event.nativeEvent.isComposing,
      // eslint-disable-next-line sonarjs/deprecation,@typescript-eslint/no-deprecated -- isComposing だけでは Safari で漏れるため
      keyCode: event.nativeEvent.keyCode,
      insidePopup: target instanceof Element && target.closest(POPUP_SELECTOR) !== null,
    })
    if (handled) {
      onEscape()
    }
  }
}
